var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email-icon_svg__clip0_7114_140669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 27.25c0 11-8.188 20.125-18.75 21.625l-22.813-12.25c-1.437-2.813-2.187-6-2.187-9.375 0-12.063 9.813-21.875 21.875-21.875C90.188 5.375 100 15.188 100 27.25z",
    fill: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 48.875v31.5c0 3.438-2.813 6.25-6.25 6.25H6.25c-3.438 0-6.25-2.813-6.25-6.25v-37.5c0-3.438 2.813-6.25 6.25-6.25h52.187l22.813 12.25z",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.403 37L44.97 60.123l-3.404 6.118L0 43.117 3.403 37z",
    fill: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.38 37L38.059 59.989l3.403 6.117 41.323-22.989L79.38 37z",
    fill: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 42.875v6c-1 .188-2.063.25-3.125.25-8.687 0-16.25-5.125-19.688-12.5H75c3.438 0 6.25 2.813 6.25 6.25z",
    fill: "#E1EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7 17.474l-10.67 10.67-4.42-4.42-4.419 4.42 8.84 8.838 15.088-15.089-4.42-4.42z",
    fill: "#F4F7FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email-icon_svg__clip0_7114_140669"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/email-icon.361944623a9b7eae46ce17d9340d0cca.svg";
export { SvgEmailIcon as ReactComponent };